module.exports = __webpack_public_path__ + "img/weddings_08_V.37b455a2.webp";